import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        try {
            const savedLanguage = localStorage.getItem('amcardmate_language');
            return savedLanguage || 'en-US';
        } catch (error) {
            return 'en-US';
        }
    });

    useEffect(() => {
        const handleStorageChange = () => {
            try {
                const savedLanguage = localStorage.getItem('amcardmate_language');
                if (savedLanguage && savedLanguage !== language) {
                    setLanguage(savedLanguage);
                }
            } catch (error) {
                console.error('Error reading language from storage:', error);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        const checkInterval = setInterval(() => {
            try {
                const savedLanguage = localStorage.getItem('amcardmate_language');
                if (savedLanguage && savedLanguage !== language) {
                    setLanguage(savedLanguage);
                }
            } catch (error) {
                console.error('Error checking language:', error);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(checkInterval);
        };
    }, [language]);

    const value = {
        language,
        setLanguage: (newLanguage) => {
            try {
                localStorage.setItem('amcardmate_language', newLanguage);
                setLanguage(newLanguage);
            } catch (error) {
                console.error('Error setting language:', error);
            }
        }
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageContext;